/**
 * @module shop/return-payment
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */
/** */
export const RETURN_PAYMENT_CONSTANTS = {
  RETURN_PAYMENT_MODULE: 'ReturnPaymentModule',
  INSTORE_RETURN_PAYMENT_COMPONENT: 'InstoreReturnPaymentComponent',
  DEBIT: 'Debit',
  HYBRID: 'Hybrid',
  CREDIT: 'Credit',
  UPDATE: 'Update',
  ORDER_REVIEW: '/cart/order-review',
  REPRETAIL: 'REPRetail',
  CASH: 'Cash',
  PREPAID: 'Prepaid',
  BILLING: 'BILLING',
  REFUND: 'REFUND',
  MAX_VALUE: 999999,
  MIN_VALUE: 1,
  GIFT_CARD: 'GiftCard',
  USD: 'USD',
  MAILING: 'MAILING',
  ERROR_CODE_500: '500',
  DEVICE_TABLET: 'Tablet',
  RETURN_PAYMENT_URL: '/cart/return/payment',
  MAX_AMOUNT: 1000.0,
  RETURN: 'RETURN',
  SUBMIT: 'SUBMIT',
  INVENTORY_CHECK_INDICATOR: 'N',
  BLOCKED: 'BLOCKED',
  INVALID: 'INVALID',
  BUTTON_PRIMARY: 'btn btn-primary',
  BACK: 'back',
  DOLLAR: '$',
  REFUND_SEQUENCE_NO: 'refundSequenceNo',
  SAVED_ADDRESS: 'Saved Address',
};

export const COUNTRY_CONST = {
  UK: 'UNITED KINGDOM',
  US: 'UNITED STATES OF AMERICA',
  CANADA: 'CANADA',
  UNITED_STATES: 'USA',
  NAME: 'name',
  CODE: 'code',
  STATE: 'State',
};

export const CARD_CONSTANT = {
  TWELVE: 12,
  SIXTEEN: 16,
  FOUR: 4,
  SEVEN: 7,
  EIGHT: 8,
  TWO: 2,
  NEGATIVE_FOUR: -4,
};
